import { User } from '@/models/User';

export interface NewGroupUsersState {
  addedUser: User[];
}

export const newUserState: NewGroupUsersState = {
  addedUser: [],
};
